export default __webpack_public_path__ + "static/media/aarp-gallery2.eafeb371.jpg";